import { FC } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next";

interface IPaginationProps {
  totalPages: number;
  currentPage: number;
  route: string;
}

const Pagination: FC<IPaginationProps> = ({ totalPages, currentPage, route }) => {
  const { t } = useTranslation();

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav>
      <div className="nav-links">
        <ul className="rbt-pagination">
          <li className={currentPage === 1 ? "disabled" : ""}>
            <Link
              href={{
                pathname: route,
                query: { page: currentPage > 1 ? currentPage - 1 : 1 }
              }}
              aria-label={t("previous")}
            >
              <i className="feather-chevron-left" />
            </Link>
          </li>
          {pages.map(num => (
            <li key={num} className={currentPage === num ? "active" : ""}>
              <Link
                href={{
                  pathname: route,
                  query: { page: num }
                }}
              >
                {num}
              </Link>
            </li>
          ))}
          <li className={currentPage === totalPages ? "disabled" : ""}>
            <Link
              href={{
                pathname: route,
                query: { page: currentPage < totalPages ? currentPage + 1 : totalPages }
              }}
              aria-label={t("next")}
            >
              <i className="feather-chevron-right" />
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Pagination;
